var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMFlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 40,
    viewBox: "0 0 193 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 16.0818C103.434 15.7863 102.365 16.201 102.012 17.008L98.1066 25.9208L94.2 17.0031C93.8463 16.1958 92.777 15.7812 91.8117 16.0769C90.8462 16.3725 90.3504 17.2665 90.7038 18.0738L96.3536 30.9707C96.4686 31.2343 96.6616 31.4559 96.9016 31.6246C96.9056 31.6278 96.9106 31.6311 96.9156 31.6343C96.9286 31.6439 96.9426 31.6534 96.9566 31.6625C96.9736 31.673 96.9896 31.6834 97.0056 31.6935C97.0086 31.6951 97.0116 31.6969 97.0136 31.6986C97.1506 31.7816 97.3026 31.8505 97.4686 31.9015C98.4346 32.197 99.5036 31.7823 99.8576 30.9753L105.507 18.0784C105.861 17.2712 105.365 16.3773 104.4 16.0818Z",
    fill: "url(#paint0_linear_285_14402)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.391 12.96C190.425 12.6063 189.356 13.1024 189.003 14.0679L185.098 24.728L181.255 14.2366C181.125 13.7398 180.791 13.3044 180.313 13.0565C180.308 13.0538 180.303 13.051 180.297 13.0482C180.283 13.0407 180.268 13.0335 180.253 13.0265C179.815 12.815 179.296 12.7736 178.803 12.9542C178.195 13.1769 177.774 13.683 177.633 14.2685L173.802 24.7278L169.895 14.0618C169.542 13.0963 168.472 12.6004 167.507 12.9539C166.542 13.3076 166.046 14.3769 166.399 15.3422L172.049 30.7676C172.164 31.083 172.357 31.348 172.597 31.5498C172.601 31.5537 172.606 31.5574 172.611 31.5614C172.624 31.5728 172.638 31.584 172.652 31.5951C172.668 31.6077 172.685 31.62 172.701 31.6321C172.704 31.6342 172.707 31.6361 172.709 31.6382C172.846 31.7373 172.998 31.8199 173.164 31.8809C174.13 32.2346 175.199 31.7385 175.553 30.773L179.45 20.1328L183.345 30.7674C183.46 31.0827 183.653 31.3478 183.892 31.5495C183.897 31.5535 183.902 31.5572 183.906 31.5612C183.92 31.5726 183.934 31.5837 183.948 31.5949C183.964 31.6075 183.98 31.6198 183.997 31.6319C184 31.634 184.002 31.6359 184.005 31.638C184.142 31.7371 184.294 31.8197 184.46 31.8807C185.426 32.2344 186.495 31.7383 186.848 30.7728L192.498 15.3473C192.852 14.3818 192.356 13.3125 191.39 12.959L191.391 12.96Z",
    fill: "url(#paint1_linear_285_14402)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4811 18.4948C81.7864 18.4948 83.0137 19.003 83.9366 19.9262C84.8595 20.8491 85.3679 22.0763 85.3679 23.3816C85.3679 24.6868 84.8597 25.9141 83.9366 26.837C83.0137 27.7599 81.7864 28.2684 80.4811 28.2684C79.1759 28.2684 77.9486 27.7601 77.0257 26.837C76.1028 25.9141 75.5944 24.6868 75.5944 23.3816C75.5944 22.0763 76.1026 20.8491 77.0257 19.9262C77.9486 19.0032 79.1759 18.4948 80.4811 18.4948ZM80.4811 14.7715C75.7261 14.7715 71.8711 18.6263 71.8711 23.3816C71.8711 28.1369 75.7258 31.9916 80.4811 31.9916C85.2365 31.9916 89.0912 28.1369 89.0912 23.3816C89.0912 18.6263 85.2365 14.7715 80.4811 14.7715Z",
    fill: "url(#paint2_linear_285_14402)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.176 18.4948C157.481 18.4948 158.708 19.003 159.631 19.9262C160.554 20.8491 161.063 22.0763 161.063 23.3816C161.063 24.6868 160.555 25.9141 159.631 26.837C158.708 27.7599 157.481 28.2684 156.176 28.2684C154.871 28.2684 153.643 27.7601 152.721 26.837C151.798 25.9141 151.289 24.6868 151.289 23.3816C151.289 22.0763 151.797 20.8491 152.721 19.9262C153.643 19.0032 154.871 18.4948 156.176 18.4948ZM156.176 14.7715C151.421 14.7715 147.566 18.6263 147.566 23.3816C147.566 28.1369 151.421 31.9916 156.176 31.9916C160.931 31.9916 164.786 28.1369 164.786 23.3816C164.786 18.6263 160.931 14.7715 156.176 14.7715Z",
    fill: "url(#paint3_linear_285_14402)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.344 22.9024C124.344 22.7549 124.326 22.6118 124.294 22.4743C123.841 18.1455 120.18 14.7715 115.732 14.7715C110.976 14.7715 107.121 18.6263 107.121 23.3816C107.121 28.1369 110.976 31.9916 115.732 31.9916C117.244 31.9916 118.666 31.6009 119.901 30.9156C120.031 30.8577 120.153 30.786 120.265 30.702C120.293 30.6848 120.32 30.6678 120.348 30.6503C120.344 30.6487 120.341 30.6466 120.338 30.645C120.763 30.2938 121.033 29.7625 121.033 29.168C121.033 28.1106 120.177 27.2535 119.12 27.2535C118.581 27.2535 118.095 27.4767 117.748 27.8351C117.122 28.1185 116.438 28.2684 115.731 28.2684C114.426 28.2684 113.199 27.7601 112.276 26.837C111.689 26.2499 111.27 25.5394 111.042 24.7643H120.42C120.42 24.7664 120.419 24.7685 120.419 24.7706H124.23C124.303 24.3184 124.341 23.8544 124.341 23.3816C124.341 23.2787 124.339 23.1766 124.336 23.0746C124.341 23.0179 124.344 22.9603 124.344 22.9024ZM111.439 21.0408C111.661 20.6364 111.941 20.261 112.276 19.9259C113.199 19.003 114.426 18.4946 115.731 18.4946C117.037 18.4946 118.264 19.0028 119.187 19.9259C119.522 20.261 119.802 20.6364 120.023 21.0408H111.439Z",
    fill: "url(#paint4_linear_285_14402)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.067 30.1271V9.86163C146.067 8.83348 145.233 8 144.205 8C143.177 8 142.344 8.83348 142.344 9.86163V30.1271C142.344 31.1553 143.177 31.9888 144.205 31.9888C145.233 31.9888 146.067 31.1553 146.067 30.1271Z",
    fill: "url(#paint5_linear_285_14402)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.008 8C126.472 8 126.021 8.62144 125.886 9.46718C125.858 9.59432 125.844 9.72629 125.844 9.86163V30.1271C125.844 31.1553 126.677 31.9888 127.705 31.9888C128.733 31.9888 129.567 31.1553 129.567 30.1271V22H139.68C140.323 22 140.844 21.105 140.844 20.0005C140.844 18.896 140.323 18 139.68 18H129.567V12H139.68C140.323 12 140.844 11.105 140.844 10.0005C140.844 8.89605 140.323 8 139.68 8H127.008Z",
    fill: "url(#paint6_linear_285_14402)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3714 30.1271V14.5511L57.7017 20.8814C57.7186 20.8996 57.736 20.9176 57.7538 20.9354C58.0752 21.2568 58.4787 21.4459 58.8969 21.5028C59.4955 21.585 60.1242 21.3959 60.5844 20.9357C60.6048 20.9153 60.6246 20.8946 60.644 20.8736L66.6484 14.8691V30.1271C66.6484 31.1553 67.4814 31.9888 68.5094 31.9888C69.5374 31.9888 70.3714 31.1553 70.3714 30.1271V9.86163C70.3714 8.83348 69.5374 8 68.5094 8C67.7911 8 67.168 8.40698 66.8577 9.00297L59.1689 16.6918L51.1215 8.64438C50.8346 8.35744 50.4822 8.17592 50.1124 8.09981C49.9233 8.03511 49.7204 8 49.5094 8C48.4814 8 47.6484 8.83348 47.6484 9.86163V30.1271C47.6484 31.1553 48.4814 31.9888 49.5094 31.9888C50.5374 31.9888 51.3714 31.1553 51.3714 30.1271Z",
    fill: "url(#paint7_linear_285_14402)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3187 19.436C30.2492 19.3761 30.1773 19.3208 30.1032 19.2701L20.4202 10.8789L29.9108 0H23.2772L7.81352 17.7256C6.90626 18.765 7.01688 20.341 8.05973 21.2448C8.12465 21.3016 8.19225 21.3539 8.26139 21.4023L17.9378 29.7881L9.69065 39.3H16.3349L30.4093 23.1338C31.4038 21.9984 31.3635 20.341 30.3187 19.436ZM21.2299 26.0288L13.2421 19.1068L17.1354 14.6443L25.1313 21.574L21.2299 26.0288Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4675 0L29.189 0.63032L20.25 10.8768L29.9272 19.263C30.0033 19.3152 30.0774 19.3721 30.1488 19.4339C31.1936 20.3393 31.3023 21.9179 30.392 22.9573L22.3081 32.1855L28.3543 39.2999H39.0697L39.3344 0H28.4675Z",
    fill: "url(#paint8_linear_285_14402)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7646 29.7837L8.09083 21.4006C8.02169 21.3518 7.95409 21.2991 7.88879 21.2427C6.84556 20.3385 6.73532 18.7629 7.64219 17.7231L16.8646 7.15131L9.96451 0H0V39.2999H9.51395L17.7646 29.7837Z",
    fill: "url(#paint9_linear_285_14402)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_285_14402",
    x1: 0.467118,
    y1: 3.27544,
    x2: 194.621,
    y2: 27.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F143E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40187F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_285_14402",
    x1: 0,
    y1: 0,
    x2: 39,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB36F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9D00C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_285_14402",
    x1: 0,
    y1: 0,
    x2: 39,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB36F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9D00C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMFlogo);
export default __webpack_public_path__ + "static/media/MFlogo.b25f776d2b1dcd0caf63eb17377a4993.svg";
export { ForwardRef as ReactComponent };